/* eslint-disable import/first */
import React from 'react';
import { Button } from '@material-ui/core';
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import { orderInProgressAccountDeleteGA } from 'spwa-ui-library/esm/utils/helperGA';
const { selectDesktop } = Slices.appSlice;
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import orderProcessImg from './images/Oder_processing.svg';
import BackButton from '../../components/BackButton';

const DeleteAccountError = ({ onClose }) => {
  const isDesktop = useSelector(selectDesktop);
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => {
    orderInProgressAccountDeleteGA('Cancel');
    if (isDesktop) {
      navigate(`/${intl.locale}/home`, { replace: true });
    } else {
      onClose();
    }
  };

  const handleTrackOrderNavigation = () => {
    orderInProgressAccountDeleteGA('TrackOrder');
    navigate(`/${intl.locale}/track-order`, {
      state: {
        oldLocation: location?.state?.oldLocation,
      },
    });
  };
  return (
    <>
      <div className={css.deleteAccount}>
        <div className={css.buttonWrapper}>
          <div className={css.spacer}></div>
          <BackButton type="cross" className={css.customButton} handleBack={handleClose} />
        </div>
        <div className={css.main}>
          <div className={css.attentionIcon}>
            {/* <EmotionNormal /> */}
            <img src={orderProcessImg} alt="Order Processing" />
          </div>
          <div className={css.deleteAccountFailContainer}>
            <div className={css.heading}>
              <FormattedMessage id="oops_order_in_progress" />
              ...
            </div>
            <div className={css.warning}>
              <FormattedMessage id="account_deletion_cannot_happen" />
            </div>
          </div>
          <div className={css.actionContainerDelete}>
            <Button
              variant="outlined"
              color="primary"
              className={css.trackBtn}
              onClick={handleTrackOrderNavigation}
            >
              <FormattedMessage id="track_order" />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteAccountError;
